import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Loadable from 'react-loadable'
import { RootState } from '../../types/rootstate'
import {
  agentIdSelector,
  agentNameSelector,
} from '../../selectors/activeconversation'
import { formVersionIdSelector } from '../../selectors/forms'
import { uploadFormFile } from '../../actions/forms'
import { setFormValue } from '../../actions/form-values'
import { FormValues } from '@imbox/form-renderer/lib/types/form-value'
import { strings } from '../localization'
import { CustomFormFieldFn } from '@imbox/form-renderer/lib/components/form-type-selector'

export const LoadableFormBuilder = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "widget-formbuilder" */ '@imbox/form-renderer'
    ).then((c) => {
      return c
    }),
  render(loaded, props) {
    const Component = loaded.FormRenderer

    return <Component {...props} />
  },
  loading: () => null,
  delay: 300,
})

type Props = {
  form: any
  formId: string
  instanceId: string
  companyName: string
  onSubmit: (values: FormValues, fileTokens: string[]) => void
  customFormField?: CustomFormFieldFn
}

export const FormBuilder: React.FC<Props> = ({
  form,
  formId,
  instanceId,
  companyName,
  onSubmit,
  customFormField,
}) => {
  const key = `${instanceId}:${formId}`
  const dispatch = useDispatch()
  const values = useSelector((state: RootState) => state.formValues[key])
  const agentId = useSelector(agentIdSelector)
  const agentName = useSelector(agentNameSelector)
  const formVersionId = useSelector((state: RootState) =>
    formVersionIdSelector(state, formId)
  )
  const language = useSelector(
    (state: RootState) => state.localization.language
  )

  const _setFormValue = (formId, id, value) =>
    dispatch(setFormValue(instanceId, formId, id, value))
  const _uploadFormFile = (id, uniqLocalId, file, onProgress) =>
    dispatch(uploadFormFile(id, uniqLocalId, file, onProgress))

  return (
    <LoadableFormBuilder
      form={form}
      formId={formId}
      languageCode={language}
      localizationFormatValues={{
        companyName,
        agentName,
        agentId,
        urlencodedAgentName: encodeURIComponent(agentName),
      }}
      values={values}
      versionId={formVersionId}
      consentText={strings.formsConsent}
      onSubmit={onSubmit}
      uploadFile={_uploadFormFile}
      setFormValue={_setFormValue}
      customFormField={customFormField}
    />
  )
}
